import { render, staticRenderFns } from "./image-filter.vue?vue&type=template&id=9db4ece8&"
import script from "./image-filter.vue?vue&type=script&lang=js&"
export * from "./image-filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports